import { render, staticRenderFns } from "./attentionRemoveItems.vue?vue&type=template&id=e5ecfdf2&scoped=true&"
import script from "./attentionRemoveItems.vue?vue&type=script&lang=js&"
export * from "./attentionRemoveItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ecfdf2",
  null
  
)

export default component.exports